import { IProaFormBasicDataMasters } from "@models/*";
import { BatchGridColumnProps } from "@/components/ui/aea-batch-grid/aea-batch-grid";
import { Utilities, Enums, Constants, String, GridUtilities } from "@utils";
import DataGrid from "devextreme/ui/data_grid";
import { BasePresenter } from "@presenters/base/base.presenter";
import { IFormProa } from '@interfaces/screens/form-proa.interface';


export class ProaFormFFRRPresenterExtension extends BasePresenter<IFormProa> {

    constructor(view: any) {
        super(view);
        this.showExcelModal = this.showExcelModal.bind(this);
    }    
    /************************************ */
    //#region columns
    protected getDataColumnsBS(masters: any, currentBudget: any) {
        const columns: BatchGridColumnProps[] = [];
        columns.push(this.getGridFieldProps(Enums.ProaBasicFields.IndicadorLE1, masters, currentBudget));
        columns.push(this.getGridFieldProps(Enums.ProaBasicFields.PProaUnidadMedida, masters, currentBudget));
        columns.push(this.getGridFieldProps(Enums.ProaBasicFields.LineaBase, masters, currentBudget));
        columns.push(this.getGridFieldProps(Enums.ProaBasicFields.PProaAnioLineaBase, masters, currentBudget));
        columns.push(this.getGridFieldProps(Enums.ProaBasicFields.MetaFinal, masters, currentBudget));
        columns.push(this.getGridFieldProps(Enums.ProaBasicFields.Meta, masters, currentBudget));
        //columns.push(this.getGridFieldProps(Enums.ProaBasicFields.TotalMeta, masters, currentBudget));

        return columns;
    }
    protected getDataColumnsBF(masters: any, currentBudget: any) {
        const columns: BatchGridColumnProps[] = [];
        columns.push(this.getGridFieldProps(Enums.ProaBasicFields.BeneficiarioAnio, masters, currentBudget));
        columns.push(this.getGridFieldProps(Enums.ProaBasicFields.TotalHombres, masters, currentBudget));
        columns.push(this.getGridFieldProps(Enums.ProaBasicFields.TotalMujeres, masters, currentBudget));
        columns.push(this.getGridFieldProps(Enums.ProaBasicFields.TotalGeneral, masters, currentBudget));
        columns.push(this.getGridFieldProps(Enums.ProaBasicFields.Id, masters, currentBudget));
        return columns;
    }
    protected getDataColumnsImplementers(masters: any, currentBudget: any, currentBudgetDetails?:any) {
        const columns: BatchGridColumnProps[] = [];
        let Meta = this.getGridFieldProps(Enums.ProaBasicFields.Meta, masters, currentBudget);
        Meta.fieldType = Enums.FieldTypes.currency;

        columns.push(this.getGridFieldProps(Enums.ProaBasicFields.Indice, masters, currentBudget));
        columns.push(this.getGridFieldProps(Enums.ProaBasicFields.Implementador, masters, currentBudget, currentBudgetDetails));
        columns.push(Meta);
        columns.push(this.getGridFieldProps(Enums.ProaBasicFields.TotalImplementadores, masters, currentBudget));

        return columns;
    }
    protected getDataColumnsCounterparts(masters: any, currentBudget: any) {
        const columns: BatchGridColumnProps[] = [];
        let Meta = this.getGridFieldProps(Enums.ProaBasicFields.Meta, masters, currentBudget);
        Meta.fieldType = Enums.FieldTypes.currency;

        columns.push(this.getGridFieldProps(Enums.ProaBasicFields.Indice, masters, currentBudget));
        columns.push(this.getGridFieldProps(Enums.ProaBasicFields.PProaTipoContrapartida, masters, currentBudget));
        columns.push(this.getGridFieldProps(Enums.ProaBasicFields.IdContrapartida, masters, currentBudget));
        columns.push(Meta);
        columns.push(this.getGridFieldProps(Enums.ProaBasicFields.TotalContrapartidas, masters, currentBudget));

        return columns;
    }
    protected getDataColumnsLocation(masters: any, currentBudget: any, currentBudgetDetails?:any) {
        const columns: BatchGridColumnProps[] = [];
        columns.push(this.getGridFieldProps(Enums.ProaBasicFields.Indice, masters, currentBudget));
        columns.push(this.getGridFieldProps(Enums.ProaBasicFields.Location, masters, currentBudget, currentBudgetDetails));
        columns.push(this.getGridFieldProps(Enums.ProaBasicFields.Meta, masters, currentBudget));
        columns.push(this.getGridFieldProps(Enums.ProaBasicFields.TotalLocation, masters, currentBudget));
        return columns;
    }
    protected getDataColumnsADT(masters: any, currentBudget: any, currentBudgetDetails?: any) {
        const columns: BatchGridColumnProps[] = [];
        columns.push(this.getGridFieldProps(Enums.ProaBasicFields.Indice, masters, currentBudget));
        columns.push(this.getGridFieldProps(Enums.ProaBasicFields.ADT, masters, currentBudget, currentBudgetDetails));
        columns.push(this.getGridFieldProps(Enums.ProaBasicFields.Meta, masters, currentBudget));
        columns.push(this.getGridFieldProps(Enums.ProaBasicFields.TotalADT, masters, currentBudget));
        return columns;
    }
    protected getSumActivityColumns(masters: any, currentBudget: any, currentLabels: any) {
        const columns: BatchGridColumnProps[] = [];

        let PProaValorActividad = this.getGridFieldProps(Enums.ProaBasicFields.PProaValorActividad, masters, currentBudget);
        PProaValorActividad.fieldType = Enums.FieldTypes.currency;
        PProaValorActividad.title = currentLabels.get('PresupuestoTotal');
        PProaValorActividad.description = currentLabels.get('PresupuestoTotal');

        columns.push(this.getGridFieldProps(Enums.ProaBasicFields.Meta, masters, currentBudget));
        columns.push(PProaValorActividad);
        return columns;
    }
    protected getDataColumnsBsIR(masters: any, currentBudget: any) {
        const columns: BatchGridColumnProps[] = [];
        columns.push(this.getGridFieldProps(Enums.ProaBasicFields.LineaBase, masters, currentBudget));
        columns.push(this.getGridFieldProps(Enums.ProaBasicFields.MetaFinal, masters, currentBudget));
        columns.push(this.getGridFieldProps(Enums.ProaBasicFields.Meta, masters, currentBudget));
        return columns;
    }
    protected getDataColumnsSummary(dtGrid: DataGrid, masters: any, currentBudget: any, nameColumnAdd: string) {
        const oColumns = dtGrid.getVisibleColumns();
        const dataColumns = oColumns.slice(2, oColumns.length - 1);
        const columns: BatchGridColumnProps[] = dataColumns.map((x: any) => {
            return {
                alignment: x.alignment,
                dataField: String.Format("{0}-{1}", Enums.ProaBasicFields.MetaValor, x.caption),
                title: x.caption,
                fieldType: Enums.FieldTypes.Number,
                id: x.caption,
                readOnly: true,
                visible: true
            }
        });
        columns.push(this.getGridFieldProps(nameColumnAdd, masters, currentBudget));
        return columns;
    }
    public getDataColumnsProducts(masters: any, currentBudget: any) {
        const columns: BatchGridColumnProps[] = [];
        columns.push(this.getGridFieldProps(Enums.ProaBasicFields.Indice, masters, currentBudget));
        columns.push(this.getGridFieldProps(Enums.ProaBasicFields.CodigoProducto, masters, currentBudget));
        columns.push(this.getGridFieldProps(Enums.ProaBasicFields.IndicadorProducto, masters, currentBudget));
        columns.push(this.getGridFieldProps(Enums.ProaBasicFields.LineaBase, masters, currentBudget));
        columns.push(this.getGridFieldProps(Enums.ProaBasicFields.MetaTotalProyecto, masters, currentBudget));
        columns.push(this.getGridFieldProps(Enums.ProaBasicFields.TotalProyecto, masters, currentBudget));
        columns.push(this.getGridFieldProps(Enums.ProaBasicFields.Meta, masters, currentBudget));
        columns.push(this.getGridFieldProps(Enums.ProaBasicFields.SubTotal, masters, currentBudget));
        return columns;
    }
    protected getDataColumnsSummaryActivities(masters: any, currentBudget: any, currentLabels: any, activitySummary?: boolean) {
        const columns: BatchGridColumnProps[] = [];
        const objColumn = this.getGridFieldProps(Enums.ProaBasicFields.ObjetivoEspecifico, masters, currentBudget);
        objColumn.groupIndex = 0;
        columns.push(objColumn);
        const resColumn = this.getGridFieldProps(Enums.ProaBasicFields.PProaResultadoEsperado, masters, currentBudget);
        resColumn.groupIndex = 1;
        columns.push(resColumn);
        const actColumn = this.getGridFieldProps(Enums.ProaBasicFields.PProaActividad, masters, currentBudget);
        actColumn.groupIndex = 2;
        columns.push(actColumn);
        const yearColumn = {
            title: currentLabels.get('proaAnios') ?? 'Años',
            alignment: 'center',
            id: 'year',
            dataField: 'year',
            visible: true,
            fieldType: 'string',
            sortOrder: "asc"
        };
        columns.push(yearColumn);
        const valColumn = this.getGridFieldProps(Enums.ProaBasicFields.PProaValorActividad, masters, currentBudget);
        columns.push(valColumn);
        return columns;
    }
    protected getActSummaryDataSource(data: any) {
        const dataSource: any[] = [];
        data.forEach((objetive: any) => {
            const objetiveName = objetive.genericInfo.PProaObjetivo;
            objetive.results.forEach((result: any) => {
                const resultName = result.genericInfo.PProaResultadoEsperado;
                result.activities.forEach((activity: any) => {
                    const activityName = activity.genericInfo.PProaActividad;
                    activity.years.forEach((year: any) => {
                        const item: any = {};
                        item.PProaObjetivo = objetiveName;
                        item.PProaResultadoEsperado = resultName;
                        item.PProaActividad = activityName;
                        item.year = year.PPresAnioMeta;
                        item.PProaValorActividad = year.PProaAnioValue;
                        dataSource.push(item);
                    });

                });
            });
        });
        return dataSource;
    }
    protected getGridFieldProps(fieldName: string, masters: any, currentBudget: any, currentBudgetDetails?:any): BatchGridColumnProps {
        const fieldDefinition = this.view.state.dataColumns.get(fieldName);
        const field: BatchGridColumnProps = {
            alignment: "center",
            dataField: fieldDefinition?.Title || "",
            title: fieldDefinition?.NombreColumna || "",
            fieldType: fieldDefinition?.TipoCampoProyecta || Enums.FieldTypes.Text,
            id: `${fieldDefinition?.Title || ""}_ffrr`,
            readOnly: fieldDefinition.OCTAVIASoloVista,
            visible: fieldDefinition.OCTAVIAVisible,
            minValue:0
        };
        return this.getSpecificProps(field, fieldName, masters, currentBudget, currentBudgetDetails);
    }
        
    private getSpecificProps(field: BatchGridColumnProps, fieldName: string, masters: any, currentBudget: any, currentBudgetDetails?:any): BatchGridColumnProps {
        if (fieldName === Enums.ProaBasicFields.LineaBase.toString()) {
            field.handleChange = true
            field.format = Constants.GeneralFormats.CURRENCY_FORMAT_NUMERAL;
        }
        if (fieldName === Enums.ProaBasicFields.PProaAnioLineaBase.toString()) {
            field.format = Constants.GeneralFormats.DATE_MESANIO_FORMAT;
            field.editorOptions = { calendarOptions : { maxZoomLevel: 'year', minZoomLevel: 'century' }};
        }
        if ([Enums.ProaBasicFields.TotalMeta.toString(), Enums.ProaBasicFields.TotalImplementadores.toString(), , Enums.ProaBasicFields.TotalContrapartidas.toString()].includes(fieldName)) {
            field.calculateCellValue = this.calculateTotalTargets;
        }
        if (fieldName === Enums.ProaBasicFields.Meta.toString()) {
            field.handleChange = true
            field.dataField = Enums.ProaBasicFields.MetaValor;            
        }
        if (fieldName === Enums.ProaBasicFields.MetaFinal.toString()) {
            field.handleChange = true
        }
        if (fieldName === Enums.ProaBasicFields.IndicadorLE1.toString()) {
            field.items = [ ...Utilities.processDropDownData(masters.strategicLines.filter((x: any) => x[Enums.ProaBasicFields.PRGCodigoLineaIntervencionId] === currentBudget[Enums.ProaBasicFields.OCTAVIALineaIntervencionId]), "", "") ];
            field.onValueChanged = this.getMeasureUnitValue.bind(this, masters, Constants.Globals.PREFIX_STRATEGIC_LINE_INDICATOR);
            field.width = 350;
        }
        if ([Enums.ProaBasicFields.TotalGeneral.toString()].includes(fieldName)) {
            field.calculateCellValue = this.calculateBeneficiariesTotal;
            field.dataField = Enums.ProaBasicFields.TotalMeta;
        }
        if ([Enums.ProaBasicFields.TotalGeneral.toString(), Enums.ProaBasicFields.TotalHombres.toString(), Enums.ProaBasicFields.TotalMujeres.toString()].includes(fieldName)) {
            field.format = Constants.GeneralFormats.NUMBER_FORMAT_NOT_DECIMAL;
            field.width = 150;
        }
        if (fieldName === Enums.ProaBasicFields.Implementador.toString()) {
            let data = masters.implementators;
            if (!Utilities.isNullEmptyObject(currentBudget.OCTAVIAPaisId)) {
                data = masters.implementators.filter((x: any) => x["OCTAVIAPaisId"] === currentBudget["OCTAVIAPaisId"] || Utilities.isNullEmptyObject(x["OCTAVIAPaisId"]));
            }else if(currentBudgetDetails && currentBudgetDetails.length){
                let countries: number[] = [];
                currentBudgetDetails.map((budDet: any)=> {if(budDet["OCTAVIAPaisId"]) countries.push(budDet["OCTAVIAPaisId"]) })
                data = masters.implementators.filter((imp: any) => (countries.includes(imp["OCTAVIAPaisId"]) || !imp["OCTAVIAPaisId"]));
            }
            field.items = Utilities.processDropDownData(data.filter((x: any) => (x.OCTAVIAActivo)), Enums.ListTypes.SLEP);
            field.allItems = Utilities.processDropDownData(data, Enums.ListTypes.SLEP);
        }
        if (fieldName === Enums.ProaBasicFields.PProaTipoContrapartida.toString()) {
            let data = masters.counterpartType;
            field.items = Utilities.processDropDownData(data, Enums.ListTypes.ProaTipoContrapartida);
        }
        if (fieldName === Enums.ProaBasicFields.IdContrapartida.toString()) {
            let data = masters.implementators;
            if (!Utilities.isNullEmptyObject(currentBudget.OCTAVIAPaisId)) {
                data = masters.implementators.filter((x: any) => x["OCTAVIAPaisId"] === currentBudget["OCTAVIAPaisId"] || Utilities.isNullEmptyObject(x["OCTAVIAPaisId"]));
            }
            let items = Utilities.processDropDownData(data.filter((x: any) => (x.OCTAVIAActivo)), Enums.ListTypes.ProaSubproyectoFRStepSDC,"", "IMP");
            data = masters.ffrrFinancer
            items = items.concat(Utilities.processDropDownData(data.filter((x: any) => (x.OCTAVIAActivo)), Enums.ListTypes.ProaSubproyectoFRStepSDC,"", "FIN"));
            data = masters.grantCodes
            items = items.concat(Utilities.processDropDownData(data.filter((x: any) => (x.OCTAVIAActivo)), Enums.ListTypes.ProaSubproyectoFRStepSDC,"", "COD"));

            let allData = masters.implementators;
            if (!Utilities.isNullEmptyObject(currentBudget.OCTAVIAPaisId)) {
                data = masters.implementators.filter((x: any) => x["OCTAVIAPaisId"] === currentBudget["OCTAVIAPaisId"] || Utilities.isNullEmptyObject(x["OCTAVIAPaisId"]));
            }
            let allItems = Utilities.processDropDownData(allData, Enums.ListTypes.ProaSubproyectoFRStepSDC,"", "IMP");
            allData = masters.ffrrFinancer
            allItems = allItems.concat(Utilities.processDropDownData(allData, Enums.ListTypes.ProaSubproyectoFRStepSDC,"", "FIN"));
            allData = masters.grantCodes
            allItems = allItems.concat(Utilities.processDropDownData(allData, Enums.ListTypes.ProaSubproyectoFRStepSDC,"", "COD"));

            field.items = items;
            field.allItems = allItems;
        }
        if (fieldName === Enums.ProaBasicFields.Indice.toString()) {
            field.width = 50;
            field.format = Constants.GeneralFormats.NUMBER_FORMAT_NOT_DECIMAL;
        }
        if (fieldName === Enums.ProaBasicFields.Location.toString()) {
            let data = masters.proaLocalization;    
            if (!Utilities.isNullEmptyObject(currentBudget.OCTAVIAPaisId)) {
                data = masters.proaLocalization.filter((x: any) => x["OCTAVIAPaisId"] === currentBudget["OCTAVIAPaisId"] || Utilities.isNullEmptyObject(x["OCTAVIAPaisId"]));
            }else if(currentBudgetDetails && currentBudgetDetails.length){
                let countries: number[] = [];
                currentBudgetDetails.map((budDet: any)=> {if(budDet["OCTAVIAPaisId"]) countries.push(budDet["OCTAVIAPaisId"]) })
                data = masters.proaLocalization.filter((loc: any) => (countries.includes(loc["OCTAVIAPaisId"]) || !loc["OCTAVIAPaisId"]));
            }
            field.items = Utilities.processDropDownData(data.filter((x: any) => (x.OCTAVIAActivo)), Enums.ListTypes.ProaLocalization);
            field.allItems = Utilities.processDropDownData(data, Enums.ListTypes.ProaLocalization);
        }
        if (fieldName === Enums.ProaBasicFields.ADT.toString()) {
            let data = masters.proaAdt;
            if (!Utilities.isNullEmptyObject(currentBudget.OCTAVIAPaisId)) {
                data = masters.proaAdt.filter((x: any) => x["OCTAVIAPaisId"] === currentBudget["OCTAVIAPaisId"] || Utilities.isNullEmptyObject(x["OCTAVIAPaisId"]));
            }else if(currentBudgetDetails && currentBudgetDetails.length){
                let countries: number[] = [];
                currentBudgetDetails.map((budDet: any)=> {if(budDet["OCTAVIAPaisId"]) countries.push(budDet["OCTAVIAPaisId"]) })
                data = masters.proaAdt.filter((adt: any) => (countries.includes(adt["OCTAVIAPaisId"]) || !adt["OCTAVIAPaisId"]));
            }
            field.items = Utilities.processDropDownData(data.filter((x: any) => (x.OCTAVIAActivo)), Enums.ListTypes.ProaAdt);
            field.allItems = Utilities.processDropDownData(data, Enums.ListTypes.ProaAdt);
        }
        if ([Enums.ProaBasicFields.TotalLocation.toString(), Enums.ProaBasicFields.TotalADT.toString()].includes(fieldName)) {
            field.dataField = Enums.ProaBasicFields.TotalADTLOC;
            field.calculateCellValue = this.calculateTotalTargets;
        }
        if (fieldName === Enums.ProaBasicFields.CodigoProducto.toString()) {
            if (Utilities.isNullEmptyObject(this.view.state.intermediateResults[0])) {
                field.readOnly = true;
                field.items = Utilities.processDropDownData([], Enums.ListTypes.Products);
            } else {
                ;
                const data = masters.products.filter((x: any) => x.PFFRRCodigoResultadoIntermedioId === this.view.state.intermediateResults[0]);
                field.items = Utilities.processDropDownData(data, Enums.ListTypes.Products);
            }
        }
        if (fieldName === Enums.ProaBasicFields.IndicadorProducto) {
            const data = masters.productsIndicators;
            field.items = Utilities.processDropDownData(data, Enums.ListTypes.ProductsIndicator);
        }
        if (fieldName.indexOf(Enums.ProaBasicFields.SubTotal) > -1) {
            field.onValueChanged = this.getSummaryValue;            
        }
        return field
    }
    private calculateTotalTargets(data: any) {
        let value = 0;
        const items = Object.keys(data);
        items.forEach(key => {
            if (key.indexOf(Enums.ProaBasicFields.MetaValor.toString()) > -1) {
                value += data[key];
            }
        });
        return value;
    }
    private calculateBeneficiariesTotal(data: any) {
        let value = data[Enums.ProaBasicFields.TotalHombres] + data[Enums.ProaBasicFields.TotalMujeres];
        if(isNaN(value)) value = "";
        return value;
    }
    protected getSummaryValue() {
        const dtGrid = DataGrid.getInstance(document.getElementById(String.Format(Enums.DataGridId.ProductsSt4, this.view.index))) as DataGrid;
        let summary = 0;
        if (!Utilities.isNullEmptyObject(dtGrid)) {
            const gridData = dtGrid.getDataSource().items();
            gridData.forEach((value: any, index: number) => {
                const keys = Object.keys(value);
                const values = keys.filter(x => x.indexOf(Enums.ProaBasicFields.SubTotal) > -1);
                values.forEach(key => { summary += value[key] })
            });
        }
        this.view.state.setTotalIntermediateResults(summary);
    }
    //#endregion
    /*********************************** */
    //#region dataSources
    
    protected dataSourceBs(masters: any) {
        const result: any = [];
        const gnData = this.view.step1Data?.genericInfo;
        let iLE = null; 
        if (!Utilities.isNullEmptyObject(gnData)) {
            if (!Utilities.isNullEmptyObject(gnData[Enums.ProaBasicFields.IndicadorLE1])) {
                iLE = gnData[Enums.ProaBasicFields.IndicadorLE1];
            }
            if (!Utilities.isNullEmptyObject(iLE)) {
                gnData[Enums.ProaBasicFields.IndicadorLE1] = iLE;

                let res = this.getMeasureUnitFromMRI(masters, iLE.toString(), Constants.Globals.PREFIX_STRATEGIC_LINE_INDICATOR);
                gnData.PProaUnidadMedida = res;    
            }

            gnData.PProaAnioLineaBase = gnData.PProaAnioLineaBase ? typeof gnData.PProaAnioLineaBase.getMonth !== 'function' ? new Date(gnData.PProaAnioLineaBase.split('/')[1], Number(gnData.PProaAnioLineaBase.split('/')[0]) - 1, 1) : gnData.PProaAnioLineaBase : null;

            result.push(gnData);
        }

        if (result.length === 0) {
            result.push({ PPresIndicadorLineaEstrategica1Id: iLE, Id: 0 });
        }
        return result;
    }
    protected getBsPivotDataSource(startDate: Date) {
        const result: any = [];
        if (!Utilities.isNullEmptyObject(startDate)) {
            if (!Utilities.isNullEmptyObject(this.view.step1Data?.baseLineYears)) {
                result.push(...this.view.step1Data?.baseLineYears)
            }
            if (result.length === 0) {
                result.push({
                    Id: 0,
                    PPresAnioMeta: new Date(startDate).getFullYear(),
                    PProaAnioValue: 0,
                    PProaFRStep1Id: 0
                });
            }
        }
        return result
    }
    private getBudgetInterventionLine(currentBudget: any, masters: IProaFormBasicDataMasters) {
        const intLine = currentBudget.OCTAVIALineaIntervencionId;
        return intLine ? masters.interventionLines.find((x: any) => x.Id === intLine)?.Id : "";
    }
    protected dataSourceBf(startDate: Date) {
        const bfData = this.view.step1Data?.beneficiaries;
        let result: any = [];
        if (!Utilities.isNullEmptyObject(startDate)) {
            if (!Utilities.isNullEmptyObject(bfData)) {
                result.push(...bfData);
            }

            if (result.length === 0) {
                result.push({
                    Id: 0,
                    PPresuAnio: new Date(startDate).getFullYear(),
                    PFFRRTotalHombres: 0,
                    PFRRTotalMujeres: 0,
                    PPresTotalAnio: 0
                })
            }
        }
        return Utilities.sortByKey(result, "PPresuAnio");
    }
    protected dataSourceImp() {
        const ImData = this.view.implementersData;
        const results: any = [];
        if (!Utilities.isNullEmptyObject(ImData)) {
            ImData.genericInfo.forEach((item: any, index: number) => {
                const newItem = { ...item.basicInfo };
                newItem.OCTAVIASLEPId = [newItem.OCTAVIASLEPId];
                newItem[Enums.ProaBasicFields.TotalImplementadores] = newItem.PProaImplementadorTotal
                newItem[Enums.ProaBasicFields.Indice] = index + 1;
                results.push({ ...newItem });
            });
        }
        if (results.length === 0) {
            results.push({
                Id: 0,
                Indice: 1
            })
        }
        return results;
    }
    protected getImpPivotDataSource(startDate: Date) {
        const imData = this.view.implementersData;
        const results: any[] = [];
        if (!Utilities.isNullEmptyObject(imData)) {
            imData.genericInfo.forEach((item: any) => {
                item.implementerYears.forEach((child: any) => {
                    child.PProaAnioValue = child.PProaAnioValue? Number(Number(child.PProaAnioValue)?.toFixed(2)) : child.PProaAnioValue
                    results.push({ ...child });
                });
            });
        }
        if (results.length === 0) {
            results.push({
                Id: 0,
                PPresAnioMeta: new Date(startDate).getFullYear(),
                PProaAnioValue: 0,
                PProaFRStep2Id: 0
            });
        }
        return results;
    }
    protected dataSourceSDC() {
        const cpData = this.view.counterpartsData;
        const results: any = [];
        if (!Utilities.isNullEmptyObject(cpData)) {
            cpData.genericInfo.forEach((item: any, index: number) => {
                const newItem = { ...item.basicInfo };

                let IdContrapartida = newItem.OCTAVIASLEPId ? `IMP${newItem.OCTAVIASLEPId}` : newItem.OCTAVIAFinanciadorSapId 
                                ? `FIN${newItem.OCTAVIAFinanciadorSapId}` : newItem.OCTAVIACodigoFinanciacionId 
                                ? `COD${newItem.OCTAVIACodigoFinanciacionId}` : newItem.Title ? `NEW${newItem.Title}` : null;
                newItem.IdContrapartida = [IdContrapartida];
                newItem.PProaTipoContrapartida = [newItem.PProaTipoContrapartidaId];
                newItem[Enums.ProaBasicFields.Indice] = index + 1;
                results.push({ ...newItem });
            });
        }
        if (results.length === 0) {
            results.push({
                Id: 0,
                Indice: 1
            })
        }
        return results;
    }
    protected getSDCPivotDataSource(startDate: Date) {
        const cpData = this.view.counterpartsData;

        const result: any[] = [];
        if (!Utilities.isNullEmptyObject(cpData)) {
            cpData.genericInfo.forEach((item: any) => {
                item.counterpartsYears.forEach((child: any) => {
                    child.PProaAnioValue = child.PProaAnioValue? Number(Number(child.PProaAnioValue)?.toFixed(2)) : child.PProaAnioValue
                    result.push({ ...child });
                });
            });
        }
        if (result.length === 0) {
            result.push({
                Id: 0,
                PPresAnioMeta: new Date(startDate).getFullYear(),
                PProaAnioValue: 0,
                PProaContrapartidaId: 0
            });
        }
        return result;
    }
    protected dataSourceLoc() {
        const data = this.view.zonaCCAAData;
        const result: any = [];
        if (!Utilities.isNullEmptyObject(data)) {
            data.zones.forEach((item: any, index: number) => {
                const newItem = { ...item.genericInfo };
                newItem.PProaLocationId = [newItem.PProaLocationId];
                newItem[Enums.ProaBasicFields.Indice] = index + 1;
                result.push({ ...newItem });
            });
        }

        if (result.length === 0) {
            result.push({
                Id: 0,
                Indice: 1,
            });
        }
        return result;
    }
    protected getLocPivotDataSource(startDate: Date) {
        const imData = this.view.zonaCCAAData;
        const result: any[] = [];
        if (!Utilities.isNullEmptyObject(imData)) {
            imData.zones.forEach((item: any) => {
                item.details.forEach((child: any) => {
                    child.PProaAnioValue = child.PProaAnioValue? Number(Number(child.PProaAnioValue)?.toFixed(2)) : child.PProaAnioValue
                    result.push({ ...child });
                });
            });
        }

        if (result.length === 0) {
            result.push({
                Id: 0,
                PPresAnioMeta: new Date(startDate).getFullYear(),
                PProaAnioValue: 0,
                PProaFRStep3Id: 0
            });
        }
        return result;
    }
    protected dataSourceAdt() {
        const data = this.view.zonaCCAAData;
        const result: any = [];
        if (!Utilities.isNullEmptyObject(data)) {
            data.adts.forEach((item: any, index: number) => {
                const newItem = { ...item.genericInfo };
                newItem.PProaAdtId = [newItem.PProaAdtId];
                newItem[Enums.ProaBasicFields.Indice] = index + 1;
                result.push({ ...newItem });
            });
        }
        if (result.length === 0) {
            result.push({
                Id: 0,
                Indice: 1,
                PProaAdtId: null
            });
        }
        return result;
    }
    protected getAdtPivotDataSource(startDate: Date) {
        const data = this.view.zonaCCAAData;
        const result: any[] = [];
        if (!Utilities.isNullEmptyObject(data)) {
            data.adts.forEach((item: any) => {
                item.details.forEach((child: any) => {
                    child.PProaAnioValue = child.PProaAnioValue? Number(Number(child.PProaAnioValue)?.toFixed(2)) : child.PProaAnioValue
                    result.push({ ...child });
                });
            });
        }
        if (result.length === 0) {
            result.push({
                Id: 0,
                PPresAnioMeta: new Date(startDate).getFullYear(),
                PProaAnioValue: 0,
                PProaFRStep3Id: 0
            });
        }
        return result;
    }
    protected dataSourceSumActivities() {
        let data: any = [];

        const objetives = this.view.state.step4  || []

        objetives.forEach((x: any) =>{
            x.results.forEach((y: any) =>{
                let auxData = y.activities.map((element: any, index: number) => {
                    const newElement: any = { ...element.genericInfo };
                    newElement[Enums.ProaBasicFields.Indice] = index + 1;
                    return newElement;
                });
                data = [...data, ...auxData]

            });
        })
        

        if (data.length === 0) {
            data.push({
                PProaActividad: '',
                PProaMedidaId: 0,
                PProaMetaTotalProyecto: 0,
                PProaValorActividad: 0,
                PProaFEStep4ResultadosEsperadosId: 0
            });
        }
        return data;
    }
    protected getSumActivityPivotDataSource(startDate:any) {
        let data: any = [];
        const objetives = this.view.state.step4 ? Utilities.copyObject(this.view.state.step4) : []

        objetives.forEach((x: any) =>{
            x.results.forEach((y: any) =>{
            y.activities.forEach((element: any, index: number) => {
                data = [...data, ...element.years, element.genericInfo];
            });
        });
        })

        data.forEach((aux: any) => { 
            aux.PProaAnioValue = aux.PProaAnioValue ? Number(Number(aux.PProaAnioValue)?.toFixed(2)) : aux.PProaAnioValue
        });

        if (data.length === 0) {
            data.push({
                PPresAnioMeta: !Utilities.isNullEmptyObject(startDate) ? new Date(startDate).getFullYear() : null,
                PFFRRSubTotal: 0,
                PProaAnioValue: null,
                PProaFEStep4ActividadId: 0
            });
        }
        return data;
    }
    protected dataSourceIrBs() {
        const results: any = [];
        const gnData = this.view.genericData;
        if (!Utilities.isNullEmptyObject(gnData)) {
            results.push(gnData);
        }

        if (results.length === 0) {
            results.push({ Id: 0 });
        }
        return results;
    }
    protected getIrBsPivotDataSource(startDate: Date) {
        const results: any = [];
        if (!Utilities.isNullEmptyObject(this.view.baseLineData)) {
            results.push(...this.view.baseLineData);
        }

        if (results.length === 0) {
            results.push({
                Id: 0,
                PPresAnioMeta: new Date(startDate).getFullYear(),
                PProaAnioValue: 0,
                PProaFRStep4LineaBaseId: 0
            });
        }
        return results;
    }
    protected dataSourcePr() {
        const data = this.view.productsData;
        const results: any = [];
        if (!Utilities.isNullEmptyObject(data)) {
            data.forEach((item: any, index: number) => {
                const newItem = { ...item.basicInfo };
                newItem.PFFRRCodigoProductoId = [newItem.PFFRRCodigoProductoId];
                newItem.PFFRRIndicadorProductoId = [newItem.PFFRRIndicadorProductoId];
                newItem[Enums.ProaBasicFields.Indice] = index + 1;
                results.push({ ...newItem });
            });
        }
        if (results.length === 0) {
            results.push({
                Id: 0,
                Indice: 1,
            });
        }
        return results;
    }
    protected getPrPivotDataSource(startDate: Date, dataSource?: any) {
        const data = dataSource || this.view.productsData;
        const results: any[] = [];
        if (!Utilities.isNullEmptyObject(data)) {
            data.forEach((item: any) => {
                item.details.forEach((child: any) => {
                    results.push({ ...child });
                });
            });
        }
        if (results.length === 0) {
            results.push({
                Id: 0,
                PPresAnioMeta: new Date(startDate).getFullYear(),
                PProaAnioValue: 0,
                PProaFRStep4LineaBaseId: 0
            });
        }
        return results;
    }
    protected dataSourceSummary(data: any, field: string) {
        let result = 0;
        data.forEach((item: any) => {
            result += item[field] || 0;
        });
        return result;
    }
    //#endregion
    /*********************************** */
    //#region gridData
    public showExcelModal(gridData: any) {
        this.view.state.setModalExcel(!this.view.state.modalExcel);
        this.view.state.setGridDataExcel(gridData);
    }
    protected getBsGridData(labels: any, gridData: any) {
        return GridUtilities.getGridProps({
            id: Enums.DataGridId.BaseLineSt1,
            toolbar: {
                title: labels.get('Linea base y metas'),
                addColumn: { icon: "plus", text: labels.get("Anio"), isYear: true, endDate: this.view.state.endDate, errorText: labels.get("AddYearError"), confirmText: labels.get("AddYearConfirm") },
                columnOptions: {
                    increase: 1,
                    baseColDataField: [Enums.ProaBasicFields.MetaValor]
                }
            },
            gridData: { ...gridData },
            readOnly: this.view.state.readOnly || false,
        });
    }
    protected getBfGridData(labels: any, gridData: any) {
        return GridUtilities.getGridProps({
            id: Enums.DataGridId.BeneficiariesSt1,
            toolbar: {
                title: labels.get('Beneficiarios'),
                addRow: { icon: "plus", text: labels.get("Anio"), isYear: true, endDate: this.view.state.endDate, errorText: labels.get("AddYearError"), confirmText: labels.get("AddYearConfirm") },
                copyExcel: { icon: "paste", text: labels.get('CopyFromExcel') },
                rowOptions: {
                    increase: 1,
                    baseColDataField: [Enums.ProaBasicFields.BeneficiarioAnio]
                }
            },
            gridData: { ...gridData },
            readOnly: this.view.state.readOnly || false,
            actionExcel: () => this.showExcelModal(gridData)
        });
    }
    protected getImpGridData(labels: any, gridData: any) {
        return GridUtilities.getGridProps({
            id: Enums.DataGridId.ImplementersSt2,
            toolbar: {
                title: labels.get('Implementadores'),
                addColumn: { icon: "plus", text: labels.get("Anio"), isYear: true, endDate: this.view.state.endDate, errorText: labels.get("AddYearError"), confirmText: labels.get("AddYearConfirm") },
                addRow: { icon: "plus", text: labels.get('Implementadores') },
                copyExcel: { icon: "paste", text: labels.get('CopyFromExcel') },
                columnOptions: {
                    increase: 1,
                    baseColDataField: [Enums.ProaBasicFields.MetaValor]
                },
                rowOptions: {
                    increase: 1,
                    baseColDataField: [Enums.ProaBasicFields.Indice]
                }
            },
            gridData: { ...gridData },
            readOnly: this.view.state.readOnly || false,
            actionExcel: () => this.showExcelModal(gridData)
        });
    }
    protected getLocGridData(labels: any, gridData: any) {
        return GridUtilities.getGridProps({
            id: Enums.DataGridId.LocationsSt3,
            toolbar: {
                title: labels.get('ZONACCAA'),
                addColumn: { icon: "plus", text: labels.get("Anio"), isYear: true, endDate: this.view.state.endDate, errorText: labels.get("AddYearError"), confirmText: labels.get("AddYearConfirm") },
                addRow: { icon: "plus", text: labels.get('ZONACCAA') },
                copyExcel: { icon: "paste", text: labels.get('CopyFromExcel') },
                columnOptions: {
                    increase: 1,
                    baseColDataField: [Enums.ProaBasicFields.MetaValor]
                },
                rowOptions: {
                    increase: 1,
                    baseColDataField: [Enums.ProaBasicFields.Indice]
                }
            },
            gridData: { ...gridData },
            readOnly: this.view.state.readOnly || false,
            actionExcel: () => this.showExcelModal('ZONACCAA',)
        });
    }
    protected getAdtGridData(labels: any, gridData: any) {
        return GridUtilities.getGridProps({
            id: Enums.DataGridId.AdtsSt3,
            toolbar: {
                title: labels.get('ADT'),
                addColumn: { icon: "plus", text: labels.get("Anio"), isYear: true, endDate: this.view.state.endDate, errorText: labels.get("AddYearError"), confirmText: labels.get("AddYearConfirm") },
                addRow: { icon: "plus", text: labels.get('ADT') },
                copyExcel: { icon: "paste", text: labels.get('CopyFromExcel') },
                columnOptions: {
                    increase: 1,
                    baseColDataField: [Enums.ProaBasicFields.MetaValor]
                },
                rowOptions: {
                    increase: 1,
                    baseColDataField: [Enums.ProaBasicFields.Indice]
                }
            },
            gridData: { ...gridData },
            readOnly: this.view.state.readOnly || false,
            actionExcel: () => this.showExcelModal('ADT')
        });
    }
    protected getBsIrGridData(labels: any, gridData: any, index: number) {
        return GridUtilities.getGridProps({
            id: String.Format(Enums.DataGridId.BaseLineSt4, index),
            toolbar: {
                title: labels.get('Linea base y metas'),
                addColumn: { icon: "plus", text: labels.get("Anio"), isYear: true, endDate: this.view.state.endDate, errorText: labels.get("AddYearError"), confirmText: labels.get("AddYearConfirm") },
                columnOptions: {
                    increase: 1,
                    baseColDataField: [Enums.ProaBasicFields.MetaValor]
                }
            },
            gridData: { ...gridData },
            readOnly: this.view.state.readOnly || false,
        });
    }
    protected getPrGridData(labels: any, gridData: any, index: number) {
        return GridUtilities.getGridProps({
            id: String.Format(Enums.DataGridId.ProductsSt4, index),
            toolbar: {
                title: labels.get('Productos'),
                addColumn: { icon: "plus", text: labels.get("Anio"), isYear: true, endDate: this.view.state.endDate, errorText: labels.get("AddYearError"), confirmText: labels.get("AddYearConfirm") },
                addRow: { icon: "plus", text: labels.get('Productos') },
                copyExcel: { icon: "paste", text: labels.get('CopyFromExcel') },
                columnOptions: {
                    increase: 1,
                    baseColDataField: [Enums.ProaBasicFields.MetaValor, Enums.ProaBasicFields.SubTotal]
                },
                rowOptions: {
                    increase: 1,
                    baseColDataField: [Enums.ProaBasicFields.Indice]
                }
            },
            gridData: { ...gridData },
            readOnly: this.view.state.readOnly || false,
            actionExcel: () => this.showExcelModal(gridData)
        });
    }
    protected getSDCGridData(labels: any, gridData: any) {
        return GridUtilities.getGridProps({
            id: String.Format(Enums.DataGridId.CounterpartsStSDC, "ffrr"),
            toolbar: {
                title: labels.get('LabelContrapartidas'),
                addColumn: { icon: "plus", text: labels.get("Anio"), isYear: true, endDate: this.view.state.endDate, errorText: labels.get("AddYearError"), confirmText: labels.get("AddYearConfirm") },
                addRow: { icon: "plus", text: labels.get('AddRowContrapartidas') },
                columnOptions: {
                    increase: 1,
                    baseColDataField: [Enums.ProaBasicFields.MetaValor]
                },
                rowOptions: {
                    increase: 1,
                    baseColDataField: [Enums.ProaBasicFields.Indice]
                }
            },
            gridData: { ...gridData },
            readOnly: this.view.state.readOnly || false
        });
    }
    protected getSummaryGridData(labels: any, gridData: any, id: string, title: string, location?: any) {
        return GridUtilities.getGridProps({
            id: id,
            toolbar: {
                title: labels.get(title),
                location: location
            },
            gridData: { ...gridData },
            readOnly: true,
        });
    }
    //#endregion
    /*********************************** */
    //#region general
    protected getSummaries(dataColumns: any) {
        const result: any[] = [];
        dataColumns.forEach((column: any) => {
            let format = column.format;
            if (Utilities.isNullEmptyObject(format)) {
                switch (column.fieldType) {
                    case Enums.FieldTypes.Number.toString():
                        format = Constants.GeneralFormats.NUMBER_FORMAT;
                        break;
                    case Enums.FieldTypes.currency.toString():
                        format = Constants.GeneralFormats.CURRENCY_FORMAT;
                        break;
                    default:
                        format = Constants.GeneralFormats.NUMBER_FORMAT_NOT_DECIMAL;
                        break;
                };
            }
            result.push({
                column: column.title,
                summaryType: 'sum',
                valueFormat: format
            })
        });
        return result;
    }
    private getMeasureUnitValue(masters: any, prefix: string, event: any) {
        if (event.value){
            if (event.value.toString().indexOf('_null') < 0){
                let currentValue = event.value.toString();
                let res = this.getMeasureUnitFromMRI(masters, currentValue, prefix);
                event.data.PProaUnidadMedida = res;
            }
        }
    }
    private getMeasureUnitFromMRI(masters: any, currentValue: string, prefix: string){
        let selReg : any = null;

        if (!prefix){
            let productIndicatorSel = masters.productsIndicators.filter((a:any)=> currentValue == (Constants.Globals.PREFIX_PRODUCT_INDICATOR + a.Id));
            let intermediateIndicatorSel = masters.intermediateResultsIndicator.filter((a:any)=> currentValue == (Constants.Globals.PREFIX_INTERMEDIATE_RESULTS + a.Id));
            let strategicLinesSel = masters.strategicLines.filter((a:any)=> currentValue == (Constants.Globals.PREFIX_STRATEGIC_LINE_INDICATOR + a.Id));

            selReg = productIndicatorSel.length > 0 ? productIndicatorSel[0] : intermediateIndicatorSel.length > 0 ? intermediateIndicatorSel[0] : strategicLinesSel.length > 0 ? strategicLinesSel[0] : "";
        } else {
            let masterQry = [];

            if (prefix === Constants.Globals.PREFIX_STRATEGIC_LINE_INDICATOR)
                masterQry = masters.strategicLines.filter((a:any)=> currentValue == a.Id);
            else if (prefix === Constants.Globals.PREFIX_PRODUCT_INDICATOR)
                masterQry = masters.productsIndicators.filter((a:any)=> currentValue == a.Id);
            else if (prefix === Constants.Globals.PREFIX_INTERMEDIATE_RESULTS)
                masterQry = masters.intermediateResultsIndicator.filter((a:any)=> currentValue == a.Id);

            selReg = masterQry.length > 0 ? masterQry[0] : "";
        }
        
        let measureUnitSel = masters.measureUnits.filter((a:any)=> selReg[Enums.ProaBasicFields.PMedidaId] == a.Id);

        return measureUnitSel.length > 0 ? measureUnitSel[0].Title : "";
    }
    //#endregion
}